/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";

export default
class Standpoints {

    private _modelDescription: Description;
    private _properties: { standpoints: any[] };

    constructor(aModelDescription: Description) {
        this._modelDescription = aModelDescription;

        // default values
        this._properties = {
            standpoints: []
        };
    }

    public getStandpoints(): any[] {
        let standpoints = [];
        for (let i = 0; i < this._properties.standpoints.length; i++) {
            let standpoint = {};

            for (let key in this._properties.standpoints[i]) {
                if (this._properties.standpoints[i][key].constructor === Array) {
                    standpoint[key] = this._properties.standpoints[i][key].slice();
                } else {
                    standpoint[key] = this._properties.standpoints[i][key];
                }
            }

            standpoints.push(standpoint);
        }

        return standpoints;
    }

    public parse(aModelDescriptionJSON: any): boolean {
        if (!aModelDescriptionJSON.hasOwnProperty("Standpoints")) {
            return false;
        }

        for (let i = 0; i < aModelDescriptionJSON.Standpoints.length; i++) {
            let standpoint = {};

            for (let key in aModelDescriptionJSON.Standpoints[i]) {
                if (aModelDescriptionJSON.Standpoints[i][key].constructor === Array) {
                    standpoint[key] = aModelDescriptionJSON.Standpoints[i][key].slice();
                } else {
                    standpoint[key] = aModelDescriptionJSON.Standpoints[i][key];
                }
            }

            this._properties.standpoints.push(standpoint);
        }

        return true;
    }

    public getJSONRepresentation(): any {
        return {
            standpoints: this.getStandpoints()
        }
    }
}